import MicroModal from 'micromodal';
import { preventEscapeKey, releaseEscapeKey } from './prevent-escape-key';

/**
 * モーダルを順番に表示させる操作を行うクラス
 */
export class ModalSequencer {
    /**
     * @param {Object[]} modalSequence
     */
    constructor(modalSequence) {
        this.modalSequence = modalSequence;
        this.modalIdSequence = this.modalSequence.map((modal) => modal.modalId);
        this.modalMap = {};
        this.modalSequence.forEach((modal) => (this.modalMap[modal.modalId] = modal));

        this.invokeSetup();
    }

    invokeSetup() {
        this.modalSequence.forEach((modal) => {
            if (modal.setup && document.getElementById(modal.modalId)) {
                modal.setup(modal);
            }
        });
    }

    showByModalId(modalId) {
        const modal = this.modalMap[modalId];

        if (modal.preventEscapeKey) {
            preventEscapeKey();
        }
        MicroModal.show(modalId, {
            awaitCloseAnimation: true,
            disableScroll: true,
            onShow: (modalDom) => {
                if (modal.onShowExtra) {
                    modal.onShowExtra(modalDom, modal);
                }
            },
            onClose: (modalDom) => {
                if (modal.preventEscapeKey) {
                    releaseEscapeKey();
                }
                if (modal.onCloseExtra) {
                    modal.onCloseExtra(modalDom, modal);
                }

                // 少し間を開けて次のモーダルを表示させる
                setTimeout(() => this.showNextOf(modalId), 500);
            },
        });
    }

    showNextOf(modalId) {
        const nextIndex = this.modalIdSequence.indexOf(modalId) + 1;

        if (nextIndex <= 0) {
            this.finalize();
            return;
        }

        this.showByIndex(nextIndex);
    }

    showByIndex(index) {
        for (let i = index; i < this.modalIdSequence.length; i += 1) {
            const modalId = this.modalIdSequence[i];

            // 次のモーダルidがDOMに定義されていれば表示させて終了
            if (modalId && document.getElementById(modalId)) {
                this.showByModalId(modalId);

                return;
            }
        }

        this.finalize();
    }

    finalize() {
        // 意図せずEscapeキーが使用不可のまま終了した場合に備えて念のために使用可能に戻しておく。
        releaseEscapeKey();
    }

    show() {
        this.showByIndex(0);
    }
}
